export default {
  startingLineups: {
    title: "Formazioni iniziali",
    labels: {
      confirmed: "CONFERMATO",
      expected: "PREVISTO",
      tbd: "DA DEFINIRE",
      noLineupAvailable: "Nessuna formazione disponibile",
    },
    empty: {
      title: "Nessuna formazione disponibile",
    },
  },
};